export default __webpack_public_path__ + "static/media/68_desktop.5ee62267.jpg";